import React from 'react'
import clsx from 'clsx'
import { Col, Icon, Row, Skeleton, Typography } from 'gu-ui-kit'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import styles from 'modules/Finance/Wallets/subcomponents/WalletHead/wallet-head.module.scss'

const WalletHeadSkeleton = () => {
  const breakpoints = useBreakpoint()
  return (
    <Skeleton shown className={'margin-bottom-24'}>
      <Skeleton shown>
        <div
          className={clsx(
            styles['wallet-head__balance'],
            styles['wallet-head__balance_skeleton'],
          )}
        />
      </Skeleton>
      <Skeleton
        shown
        className={clsx(
          styles['wallet-head__type-info'],
          styles['wallet-head__type-info_skeleton'],
        )}
      >
        <Typography
          variant={'p9'}
          noMargin
          className={styles['wallet-head__type-info_skeleton-text1']}
        >
          {' '}
        </Typography>{' '}
        <Icon name={'dot'} size={'s'} color={'inherit'} />{' '}
        <Typography
          variant={'p9'}
          noMargin
          className={styles['wallet-head__type-info_skeleton-text2']}
        >
          {' '}
        </Typography>
      </Skeleton>
      <Row alignItems={breakpoints.sm ? 'flex-start' : 'center'}>
        <Col
          s="4"
          sm="6"
          xs="4"
          className={styles['wallet-head__buttons-container']}
        >
          <Skeleton shown>
            <div
              className={clsx(
                styles['wallet-head__balance'],
                styles['wallet-head__balance_skeleton'],
              )}
              style={{ width: breakpoints.sm ? 80 : 243 }}
            ></div>
          </Skeleton>
        </Col>
        <Col s="4" sm="6" xs="4"></Col>
      </Row>
    </Skeleton>
  )
}

export default WalletHeadSkeleton
